import { render, staticRenderFns } from "./PagesOrdersId.vue?vue&type=template&id=8df5b2c8&scoped=true&"
import script from "./PagesOrdersId.vue?vue&type=script&lang=js&"
export * from "./PagesOrdersId.vue?vue&type=script&lang=js&"
import style0 from "./PagesOrdersId.vue?vue&type=style&index=0&id=8df5b2c8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8df5b2c8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VInput } from 'vuetify/lib/components/VInput';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VIcon,VInput,VSheet,VTextField})
